var _defs, _polygon, _polygon2, _polygon3, _rect, _path, _polygon4, _polygon5, _path2, _path3, _rect2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoleficaneur03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 722 235.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill: #0a1f3c;\n      }\n\n      .b {\n        fill: #ec2a28;\n      }\n\n      .c {\n        fill: none;\n        stroke: #0a1f3c;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo le ficaneur") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "98.51 119.47 77.02 119.47 77.02 52.36 57.73 52.36 57.73 139.13 98.51 139.13 98.51 119.47"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "115.59 139.13 156.36 139.13 156.36 119.47 134.88 119.47 134.88 105.28 149.59 105.28 149.59 85.61 134.88 85.61 134.88 72.03 156.36 72.03 156.36 52.36 115.59 52.36 115.59 139.13"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "199.73 170.82 219.01 170.82 219.01 139.74 235.05 139.74 235.05 121.28 219.01 121.28 219.01 70.81 240.5 70.81 240.5 52.36 199.73 52.36 199.73 170.82"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 257.58,
    y: 52.36,
    width: 19.29,
    height: 118.46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M323.12,51.41a20.91,20.91,0,0,0-5.81-.54,22.79,22.79,0,0,0-6,.54,23.48,23.48,0,0,0-17.39,22.65v74.71a23.48,23.48,0,0,0,17.41,22.66,23,23,0,0,0,6,.7,21,21,0,0,0,5.78-.7,23.49,23.49,0,0,0,17.58-22.66V134H321.39v18.35h-8.16l-.16-81,8.32,0V93.79h19.29V74.06A23.48,23.48,0,0,0,323.12,51.41Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "472.22 122.36 463.07 52.36 440.32 52.36 440.32 170.82 459.61 170.82 459.61 97.39 468.75 170.82 491.51 170.82 491.51 52.36 472.22 52.36 472.22 122.36"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "508.59 170.82 549.36 170.82 549.36 152.36 527.87 152.36 527.87 120.4 542.58 120.4 542.58 101.94 527.87 101.94 527.87 70.81 549.36 70.81 549.36 52.36 508.59 52.36 508.59 170.82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M593.72,152h-8V52.36H566.44v96.59A23,23,0,0,0,584,171.42a19.79,19.79,0,0,0,5.68.72,21.91,21.91,0,0,0,5.8-.7A23.09,23.09,0,0,0,613,148.94V52.36H593.72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M676.64,122.17V67A14.62,14.62,0,0,0,662,52.36h-32V170.82h19.29V134.75l6.22,35.91h20.8l-9.2-35C673.13,133.66,676.64,128.7,676.64,122.17ZM657.36,70.81v55.1h-8V70.81Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 57.74,
    y: 152.36,
    width: 98.63,
    height: 18.46
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M365.11,170.82s-7.82-93.54,12.64-113.1a18.39,18.39,0,0,1,25.87,0c20.46,19.56,12.64,113.1,12.64,113.1,0-11.82-31.31-31.94-36.3-27.47-1.78,1.6-.36,4.61,2,4.61h46.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoleficaneur03);
export default __webpack_public_path__ + "static/media/logo le ficaneur-03.e4aaa0a5c0d5f469805f1bc92eed86ee.svg";
export { ForwardRef as ReactComponent };